<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con">
<h2 class="contentsHead">Contents</h2>
<div class="contentsEntry"><p class="contentsEntryName1" id="epi_1">
<span href="#/xhtml/epigraph#epi1" title="Link target outside of Sample"><em class="italic">Epigraph</em></span></p></div>
<div class="contentsEntry"><p class="contentsEntryName1" id="fm_2">
<a href="#/xhtml/frontmatter#fm2"><em class="italic">A Note to Readers</em></a></p></div>
<div class="contentsEntry"><p class="contentsEntryName1" id="int_1">
<a href="#/xhtml/introduction#int">Introduction
</a></p></div>
<div class="contentsEntry"><p class="contentsEntryName2" id="pt_1">
<a href="#/xhtml/part01#pt1">PART I</a></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_1">
<a href="#/xhtml/chapter01#ch1">1. Black Tuesday</a></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_2">
<a href="#/xhtml/chapter02#ch2">2. The Flying Firefighter</a></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_3">
<a href="#/xhtml/chapter03#ch3">3. Blowback</a></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_4">
<a href="#/xhtml/chapter04#ch4">4. The First Shots Fired</a></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_5">
<a href="#/xhtml/chapter05#ch5">5. Al Qaeda’s New York Cell</a></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_6">
<a href="#/xhtml/chapter06#ch6">6. Operation Iraqi Freedom One</a></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_7">
<a href="#/xhtml/chapter07#ch7">7. A Nest of Vipers</a></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_8">
<span href="#/xhtml/chapter08#ch8" title="Link target outside of Sample">8. Blood in the City</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_9">
<span href="#/xhtml/chapter09#ch9" title="Link target outside of Sample">9. Truth from the Ashes</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_10">
<span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">10. Ice Water and Bombs</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_11">
<span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">11. A Very Dangerous Job</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_12">
<span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">12. Dot after Dot after Dot</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_13">
<span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">13. The Black Bottomless Pit</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName2" id="pt_2">
<span href="#/xhtml/part02#pt2" title="Link target outside of Sample">PART II</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_14">
<span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">14. The Fifth Battalion</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_15">
<span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">15. The Ryder Sideshow</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_16">
<span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">16. The $1.5 Million Man</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_17">
<span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">17. The Bootleg Tapes</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_18">
<span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">18. Into the Abyss</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_19">
<span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">19. The Hunt for Rashed</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_20">
<span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">20. Prepping for the “Big Noise”</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_21">
<span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">21. The Western Front</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_22">
<span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">22. The Temptress and the Spy</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_23">
<span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">23. Delivering the “Chocolates”</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_24">
<span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample">24. How Many More Fires?</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_25">
<span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample">25. The Third Plot</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_26">
<span href="#/xhtml/chapter26#ch26" title="Link target outside of Sample">26. Miracles from God</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName2" id="pt_3">
<span href="#/xhtml/part03#pt3" title="Link target outside of Sample">PART III</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_27">
<span href="#/xhtml/chapter27#ch27" title="Link target outside of Sample">27. Truth from a Value Meal</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_28">
<span href="#/xhtml/chapter28#ch28" title="Link target outside of Sample">28. Brad Smith’s Biggest “Get”</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_29">
<span href="#/xhtml/chapter29#ch29" title="Link target outside of Sample">29. A Chilling Warning</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_30">
<span href="#/xhtml/chapter30#ch30" title="Link target outside of Sample">30. John Doe No. 2</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_31">
<span href="#/xhtml/chapter31#ch31" title="Link target outside of Sample">31. The Devil Himsel</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_32">
<span href="#/xhtml/chapter32#ch32" title="Link target outside of Sample">32. The Bomb Maker and the Made Guy</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_33">
<span href="#/xhtml/chapter33#ch33" title="Link target outside of Sample">33. Shut It Down</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_34">
<span href="#/xhtml/chapter34#ch34" title="Link target outside of Sample">34. Ingenious, Diabolical, and Ruthless</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_35">
<span href="#/xhtml/chapter35#ch35" title="Link target outside of Sample">35. Reconnaissance</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_36">
<span href="#/xhtml/chapter36#ch36" title="Link target outside of Sample">36. The Drums Get Louder</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_37">
<span href="#/xhtml/chapter37#ch37" title="Link target outside of Sample">37. An Egyptian Mole in the FDNY?</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_38">
<span href="#/xhtml/chapter38#ch38" title="Link target outside of Sample">38. The Lost Chance in Malaysia</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_39">
<span href="#/xhtml/chapter39#ch39" title="Link target outside of Sample">39. “Someday Someone Will Die”</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_40">
<span href="#/xhtml/chapter40#ch40" title="Link target outside of Sample">40. The Black Hole</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName" id="ch_41">
<span href="#/xhtml/chapter41#ch41" title="Link target outside of Sample">41. Operation Iraqi Freedom Two</span></p></div>
<p class="para"> </p>
<div class="contentsEntry"><p class="contentsEntryName1" id="epilogue_1">
<span href="#/xhtml/epilogue#epilogue" title="Link target outside of Sample">Epilogue</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName1" id="anote_1">
<span href="#/xhtml/anote#anote" title="Link target outside of Sample"><em class="italic">A Note on Sources</em></span></p></div>
<div class="contentsEntry"><p class="contentsEntryName1" id="notes_1">
<span href="#/xhtml/notes#notes" title="Link target outside of Sample"><em class="italic">Notes</em></span></p></div>
<div class="contentsEntry"><p class="contentsEntryName1" id="app_1">
<span href="#/xhtml/appendix01#app1" title="Link target outside of Sample"><em class="italic">Appendix I: FBI 302 Re: Interrogation of Abdul Hakim Murad, May 11, 1995</em></span></p></div>
<div class="contentsEntry"><p class="contentsEntryName1" id="app_2">
<span href="#/xhtml/appendix02#app2" title="Link target outside of Sample"><em class="italic">Appendix II: Memo to Orrin G. Hatch Re: Investigation into Terrorism, December 5, 1995</em></span></p></div>
<div class="contentsEntry"><p class="contentsEntryName1" id="index_1">
<span href="#/xhtml/index#index" title="Link target outside of Sample"><em class="italic">Index</em></span></p></div>
<div class="contentsEntry"><p class="contentsEntryName1" id="time_1">
<span href="#/xhtml/timeline#time" title="Link target outside of Sample"><em class="italic">Timeline</em></span></p></div>
<div class="contentsEntry"><p class="contentsEntryName1" id="ata_1">
<span href="#/xhtml/abouttheauthor#ata" title="Link target outside of Sample"><em class="italic">About the Author </em></span></p></div>
<div class="contentsEntry"><p class="contentsEntryName1" id="acclaim_1">
<span href="#/xhtml/acclaim#acclaim" title="Link target outside of Sample">Acclaim</span></p></div>
<div class="contentsEntry"><p class="contentsEntryName1" id="cre_1">
<span href="#/xhtml/credits#cre" title="Link target outside of Sample"><em class="italic">Credits</em></span></p></div>
<div class="contentsEntry"><p class="contentsEntryName1" id="cop_1">
<span href="#/xhtml/copyright#cop" title="Link target outside of Sample"><em class="italic">Copyright</em></span></p></div>
<div class="contentsEntry"><p class="contentsEntryName1" id="atp_1">
<span href="#/xhtml/aboutthepublisher#atp" title="Link target outside of Sample"><em class="italic">About the Publisher</em></span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2fdebeec